import React, { useCallback } from 'react';
import { logOutOrRestart } from 'fmc-sdk';
import qs from 'qs';

import useTranslate from 'hooks/useTranslate';
import useWorkflow from 'hooks/useWorkflow';
import useFmcHost from 'hooks/useFmcHost';
import { useCondensedQueryParameters } from 'hooks/useQueryParameters';
import env from 'utils/env';

const RestartLink: React.FC = props => {
  const fmcDispatch = useFmcHost();
  const t = useTranslate();
  const { restartPath } = useWorkflow();
  const queryParams = useCondensedQueryParameters();

  const restartPathString = `${env.BASENAME}/${restartPath}/${qs.stringify(
    queryParams,
    {
      addQueryPrefix: true,
    },
  )}`.replace(/(\/)\1+/g, '/'); // regex matches duplicate "/" and collapses into one.

  const onClick = useCallback(() => {
    fmcDispatch(logOutOrRestart());
  }, [fmcDispatch]);

  const textToRender = props.children
    ? props.children
    : t('creditApplication.restartLink');

  return (
    <a id="appRestartLink" href={restartPathString} onClick={onClick}>
      {textToRender}
    </a>
  );
};

export default RestartLink;
